<template>
  <v-switch
    :input-value="isAnyItemSelected"
    @change="toggleAllItemsSelection"
    hide-details
    :disabled="isListEmpty"
    dense
    class="ma-0"
    title="Przełącz wszystkie"
    v-shortkey="toggleAllShortkeys"
    @shortkey.native="toggleAllItemsSelection"
  />
</template>

<script>
import { mapActions } from 'vuex'
import { toggleAllShortkeys } from '../../../const/shortKeys'
import { getExecutiveMultiselectTableName } from '../../../utils'
import selectionConditions from '../../../utils/selectionConditions'

export default {
  props: {
    tableName: {
      type: String,
      required: true
    }
  },
  data: () => ({
    toggleAllShortkeys
  }),
  computed: {
    isListEmpty () {
      return !this.$store.state[this.tableName].items?.length
    },
    isAnyItemSelected () {
      return !!this.$store.state[this.tableName]?.selectedItems?.length
    },
    multiselectSubject () {
      return this.$store.state[this.tableName].multiselectSubject
    },
    executiveTableName () {
      return getExecutiveMultiselectTableName(this.tableName)
    }
  },
  beforeDestroy () {
    if (this.isAnyItemSelected) this.toggleAllItemsSelection()
  },
  methods: {
    ...mapActions({
      toggleAllItemsSelection: function (dispatch) {
        const params = {
          targetTableName: this.tableName,
          selectionFunction: selectionConditions[this.multiselectSubject]
        }
        return dispatch(`${this.executiveTableName}/toggleAllItemsSelection`, params)
      }
    })
  }

}
</script>
